// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-main {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  padding: 1.5rem;
  background: var(--main-bg);
}

.page-header {
  margin-bottom: 1.5rem;
}

.page-breadcrumb {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-bottom: 0.35rem;
}

.page-breadcrumb a {
  color: var(--text-muted);
}

.page-breadcrumb a:hover {
  color: var(--primary);
}

.page-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--text);
}

.page-content {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: var(--card-shadow);
  padding: 1.25rem;
  min-height: 200px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.homepage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.stat-card__heading {
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
}

.stat-card {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: var(--card-shadow);
  padding: 1.25rem;
  border: 1px solid var(--border);
}

.stat-card__value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 0.25rem;
}

.stat-card__label {
  font-size: 0.8rem;
  color: var(--text-muted);
}

.stat-card__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
  font-size: 1.1rem;
  color: #fff;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.data-table th,
.data-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

.data-table th {
  font-weight: 600;
  color: var(--text-muted);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.data-table tbody tr:hover {
  background: var(--main-bg);
}

.placeholder-message {
  color: var(--text-muted);
  font-size: 0.9rem;
  padding: 2rem;
  text-align: center;
}

/* OrderBook */
.orderbook-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.orderbook-heading {
  margin: 0 0 0.75rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-muted);
}

.orderbook-bid { color: #16a34a; }
.orderbook-ask { color: #dc2626; }

.text-green { color: #16a34a; }
.text-red { color: #dc2626; }

@media (max-width: 768px) {
  .orderbook-grid { grid-template-columns: 1fr; }
}

/* List view (Announcement, Notifications) */
.dummy-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dummy-list-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid var(--border);
}

.dummy-list-item:last-child { border-bottom: none; }

.dummy-list-item__main { flex: 1 1; min-width: 0; }

.dummy-list-item__title {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text);
}

.dummy-list-item__message {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: var(--text-muted);
  line-height: 1.4;
}

.dummy-list-item__meta {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.badge {
  flex-shrink: 0;
  padding: 0.25rem 0.6rem;
  font-size: 0.7rem;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
}

.badge--published,
.badge--active,
.badge--verified,
.badge--completed { background: #dcfce7; color: #166534; }

.badge--draft,
.badge--pending,
.badge--open,
.badge--unread { background: #fef3c7; color: #92400e; }

.badge--read { background: #f1f5f9; color: #64748b; }

.badge--inactive,
.badge--rejected,
.badge--resolved { background: #f1f5f9; color: #64748b; }

@media (max-width: 512px) {
  .dashboard-main {
    padding: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Layout/PageLayout.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;;AAEjC,cAAc,cAAc,EAAE;AAC9B,YAAY,cAAc,EAAE;;AAE5B;EACE,kBAAkB,0BAA0B,EAAE;AAChD;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sCAAsC;AACxC;;AAEA,8BAA8B,mBAAmB,EAAE;;AAEnD,yBAAyB,SAAO,EAAE,YAAY,EAAE;;AAEhD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;;oBAGoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;;;iBAGiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;;mBAEmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".dashboard-main {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  padding: 1.5rem;\n  background: var(--main-bg);\n}\n\n.page-header {\n  margin-bottom: 1.5rem;\n}\n\n.page-breadcrumb {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-bottom: 0.35rem;\n}\n\n.page-breadcrumb a {\n  color: var(--text-muted);\n}\n\n.page-breadcrumb a:hover {\n  color: var(--primary);\n}\n\n.page-title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.page-content {\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: var(--card-shadow);\n  padding: 1.25rem;\n  min-height: 200px;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.homepage-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.stat-card__heading {\n  margin: 0 0 0.75rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.stat-card {\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: var(--card-shadow);\n  padding: 1.25rem;\n  border: 1px solid var(--border);\n}\n\n.stat-card__value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 0.25rem;\n}\n\n.stat-card__label {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.stat-card__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.75rem;\n  font-size: 1.1rem;\n  color: #fff;\n}\n\n.table-wrap {\n  overflow-x: auto;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.data-table th,\n.data-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n}\n\n.data-table th {\n  font-weight: 600;\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.data-table tbody tr:hover {\n  background: var(--main-bg);\n}\n\n.placeholder-message {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  padding: 2rem;\n  text-align: center;\n}\n\n/* OrderBook */\n.orderbook-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.orderbook-heading {\n  margin: 0 0 0.75rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.orderbook-bid { color: #16a34a; }\n.orderbook-ask { color: #dc2626; }\n\n.text-green { color: #16a34a; }\n.text-red { color: #dc2626; }\n\n@media (max-width: 768px) {\n  .orderbook-grid { grid-template-columns: 1fr; }\n}\n\n/* List view (Announcement, Notifications) */\n.dummy-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dummy-list-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.dummy-list-item:last-child { border-bottom: none; }\n\n.dummy-list-item__main { flex: 1; min-width: 0; }\n\n.dummy-list-item__title {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.dummy-list-item__message {\n  margin: 0.35rem 0 0;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n\n.dummy-list-item__meta {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.badge {\n  flex-shrink: 0;\n  padding: 0.25rem 0.6rem;\n  font-size: 0.7rem;\n  font-weight: 500;\n  border-radius: 6px;\n  text-transform: capitalize;\n}\n\n.badge--published,\n.badge--active,\n.badge--verified,\n.badge--completed { background: #dcfce7; color: #166534; }\n\n.badge--draft,\n.badge--pending,\n.badge--open,\n.badge--unread { background: #fef3c7; color: #92400e; }\n\n.badge--read { background: #f1f5f9; color: #64748b; }\n\n.badge--inactive,\n.badge--rejected,\n.badge--resolved { background: #f1f5f9; color: #64748b; }\n\n@media (max-width: 512px) {\n  .dashboard-main {\n    padding: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
